module.exports = __webpack_public_path__ + "static/media/cardFirst.89d849d9.svg";